// extracted by mini-css-extract-plugin
export default {"dynamic-media-video":"jrOAOdr"};